export default __webpack_public_path__ + "static/media/mediterraneandrink@3x.eb533f4e.jpg";